export default __webpack_public_path__ + "static/media/strategyEng0.6283aeaf.jpg";